const CAP49 = {
  "id": 314,
  "title": "La Capa 2 de Bitcoin",
  "slug": "capa-2-bitcoin",
  "type": "lesson",
  "category": "bitcoin-avanzado",
  "level": "advanced",
  "preview": "Qué es una Layer 2 en Bitcoin, cómo funciona y qué beneficios aporta Lightning Network como solución de escalabilidad.",
  "sections": [
    {
      "heading": "¿Qué es una Capa 2 (Layer 2 o L2)?",
      "text": [
        "Una **Capa 2**, también llamada *Layer 2* o *L2*, es un sistema, protocolo o red que se construye para operar de manera paralela y separada a una blockchain principal o **Capa 1 (L1)**. En el caso de Bitcoin, la L1 es la blockchain base donde se registran las transacciones definitivas.",
        "El objetivo de una L2 es permitir que los usuarios realicen operaciones fuera de la cadena principal, pero manteniendo la seguridad de Bitcoin. Estas operaciones pueden procesarse con mayor rapidez y menores costos, y posteriormente se consolidan en la blockchain principal.",
        "Las capas 2 existen porque la arquitectura de Bitcoin está diseñada para priorizar la seguridad y la descentralización, lo que limita su capacidad de procesar miles de transacciones por segundo directamente en L1. Por ello, soluciones paralelas se encargan de aliviar la carga y aumentar la eficiencia."
      ]
    },
    {
      "heading": "¿Qué se logra con una Layer 2 en Bitcoin?",
      "text": [
        "Los desarrolladores que diseñan soluciones de Capa 2 buscan alcanzar tres objetivos principales:",
        "- **Mejorar la escalabilidad:** permitir que Bitcoin procese más transacciones sin sobrecargar la cadena principal.",
        "- **Reducir costos:** ofrecer un entorno donde las transacciones sean económicas, incluso de apenas unos céntimos.",
        "- **Mantener seguridad y descentralización:** aunque las transacciones se muevan fuera de L1, siguen aseguradas por la red de Bitcoin cuando finalmente se registran en la cadena principal.",
        "Gracias a las L2, Bitcoin puede funcionar como un sistema de pagos global sin comprometer la solidez que caracteriza a su base tecnológica."
      ]
    },
    {
      "heading": "Lightning Network: la Layer 2 más importante de Bitcoin",
      "text": [
        "La **Lightning Network**, también conocida como LN, es la solución de Capa 2 más utilizada y desarrollada en el ecosistema Bitcoin.",
        "Lightning permite enviar pagos de forma **instantánea**, con comisiones extremadamente **bajas** y manteniendo una alta capacidad de procesamiento. Mientras que la L1 procesa alrededor de 7 transacciones por segundo, Lightning puede manejar miles gracias a sus canales de pago.",
        "La red funciona mediante canales de pago privados entre usuarios. Las transacciones se realizan dentro de esos canales sin necesidad de escribir cada movimiento en la cadena principal. Solo la apertura y el cierre del canal quedan registrados en la blockchain.",
        "Esto permite que, por ejemplo, dos comercios, usuarios u empresas puedan enviarse pagos continuamente en milisegundos sin congestionar la blockchain de Bitcoin.",
        "Lightning Network ha permitido casos de uso como micropagos, pagos transfronterizos instantáneos, aplicaciones financieras sobre Bitcoin e incluso nuevos modelos económicos digitales."
      ]
    },
    
  ]
}

export default CAP49;
